import { CellProps } from 'react-table'
import { PlainHeader, StackedCell, TableColumn } from '../../../../../../components'
import { NotaProfissionalList } from '../../core/_models'
import { TFunction } from '_metronic/i18n/Metronici18n'

// A nota vem inteira (sem paginação/ordenação no backend): cabeçalhos sem sort.
export const notaAtendimentosColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<NotaProfissionalList>> => [
  {
    Header: () => <PlainHeader>{t('cols.protocolo')}</PlainHeader>,
    id: 'atendimento.protocolo',
    Cell: ({ row }: CellProps<NotaProfissionalList>) => (
      <StackedCell tabular primary={row.original.atendimento?.protocolo} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.valor')}</PlainHeader>,
    id: 'valor',
    cellWidth: '160px',
    align: 'end',
    Cell: ({ row }: CellProps<NotaProfissionalList>) => (
      <StackedCell tabular primary={row.original.valorProfissionalFormatado} />
    ),
  },
]
